import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import MyWorkflowDetail from "./MyWorkflowDetail";

const MyWorkflowDetailPage = () => {
  const { productCode } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [product, setProduct] = useState(null);
  useEffect(() => {
    setProduct({
      _id: null,
      code: productCode,
      name: "",
      clockId: "",
      contractSchema: { id: "", version: "" },
      description: "",
      routing: {
        signalsEndpoint: "",
        triggersEndpoint: "",
        eventsEndpoint: "",
        productEndpoint: "",
        contractsEndpoint: "",
        workflowEndpoint: "",
      },
      signalRegister: [],
      triggerRegister: [],
      eventRegister: [],
      productRegister: [],
      workflowRegister: [],
      roleDefinitions: [],
      activityPatternDefinitions: [],
      createdDate: new Date().toISOString(),
      productTemplates: [],
      controls: [],
    });
  }, [productCode]);

  if (!product) return <Spinner />;

  const handleClose = () => {
    // Change this to window.history.back()
    window.history.back();
  };

  return (
    <>
      <MyWorkflowDetail
        product={productCode}
        baseUrl="https://workflow.poc.mrc.ai"
      />
    </>
  );
};

export default MyWorkflowDetailPage;
